/**
 * Session Expired Handler
 *
 * Module-level registry for surfacing "session is expired" events from
 * non-timer code paths (e.g. a manual refresh that returned null) into the
 * AuthProvider, so the global SessionExpiredDialog appears regardless of
 * which code path detected the expiry.
 *
 * Distinct from tokenManager.setSessionCallbacks, which is specifically for
 * timer-driven session events (warning fires, refresh-needed, expiry hit).
 */ let handler = null;
/**
 * Register the global session-expired handler. Called once by AuthProvider
 * on mount. Overwrites any previously registered handler.
 */ export function setSessionExpiredHandler(h) {
    handler = h;
}
/**
 * Notify the registered handler that the session has expired. Safe to call
 * even if no handler is registered (no-op).
 */ export function notifySessionExpired() {
    handler?.();
}
